import appLogger from "@next-platform/client-common-core/logger/appLogger";
import { importJWK, JWK, jwtVerify } from "jose";

const logger = appLogger.withTag("verifyToken");

export async function verifyToken(token: string, publicKey: JWK) {
  try {
    // validate the JWT
    const key = await importJWK(publicKey, "ES256");
    const { payload } = await jwtVerify(token, key);
    return payload;
  } catch (error) {
    logger.error("Token verification failed:", error);
    return null;
  }
}
